import ListingsRoutingResolver from './ListingRoutingResolver';

class ContactsListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "people"
    }
}

export default ContactsListingResolver
